import { Colors } from 'enums';
import { DiscountStatus } from 'interfaces';

type DiscountStatusBadgeConfig = {
  backgroundColor: string;
  i18nKey: string;
};

export const DISCOUNT_STATUS_BADGE_MAP: Partial<
  Record<DiscountStatus, DiscountStatusBadgeConfig>
> = {
  [DiscountStatus.EXPIRED]: {
    backgroundColor: Colors.red5,
    i18nKey: 'archives.status.expired',
  },
  [DiscountStatus.IN_PROGRESS]: {
    backgroundColor: Colors.green,
    i18nKey: 'archives.status.inProgress',
  },
  [DiscountStatus.NOT_EXTENDED]: {
    backgroundColor: Colors.orange2,
    i18nKey: 'archives.status.notExtended',
  },
};
